import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';

import type { SchedulesSearchPayload } from './types/reviews-schedules.types';

export type { SchedulesSearchPayload } from './types/reviews-schedules.types';

const response = {
    async postRequeueFetchResponses(profile_uuid: string, payload: any): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/schedules/${profile_uuid}/requeue-fetch-responses`,
            payload
        );
    },
    /** Search schedules. POST /reviews/schedules */
    async postGetSchedules(payload: SchedulesSearchPayload): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/schedules`,
            payload
        );
    },
    /**
     * Export the schedules matching the current filters as CSV. Same endpoint as
     * the search, with `export: true` in the body and a `text/csv` Accept header.
     */
    async postExportSchedules(payload: SchedulesSearchPayload): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/schedules`,
            payload,
            undefined,
            'application/json',
            'v1',
            {
                Accept: 'text/csv'
            }
        );
    }
};

export default response;
